const MODAL = {
  WIDTH: '1024px',
  HEIGHT: '600px',
  UPDATE_HEIGHT: '500px',
  MARK_HEIGHT: '300px',
};

export default MODAL;
